import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { AppCard, AppCardTitle, AppPageHeader } from '../../components';
import { WatchlistCompaniesTable } from '../../components/Admin';

export default function WatchlistCompaniesPage() {
	const { watchlist_id } = useParams<{ watchlist_id: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const watchlistId = parseInt(watchlist_id!, 10);

	const { watchlistName, userId } =
		(location.state as { watchlistName?: string; userId?: number }) ?? {};

	return (
		<>
			<AppPageHeader>
				<Stack direction="row" alignItems="center" spacing={2} mb={1}>
					<Button
						size="small"
						startIcon={<ArrowBackIcon />}
						onClick={() =>
							userId
								? navigate(`/admin/users/${userId}?tab=watchlists`, { state: location.state })
								: navigate(-1)
						}
					>
						Watchlists
					</Button>
				</Stack>
				<Typography variant="h5">
					Companies — {watchlistName ?? `Watchlist #${watchlistId}`}
				</Typography>
			</AppPageHeader>
			<AppCard>
				<AppCardTitle variant="h6">Tickers</AppCardTitle>
				<WatchlistCompaniesTable watchlistId={watchlistId} />
			</AppCard>
		</>
	);
}
